var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoWrapper"},[_c('div',{class:['replay',_vm.showReplayBtn==true ? 'active':''],on:{"click":_vm.replayVideo}},[_c('div',{staticClass:"caption"},[_vm._v("Replay")])]),_c('video',{attrs:{"autoplay":"","id":"ve1"},on:{"click":_vm.onVideoClick}},[_c('source',{attrs:{"src":"videos/seven.mp4","type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }